"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isNotEmpty = exports.isWebhook = exports.getTagLogs = exports.getTagStream = exports.hasAbis = exports.isContractLog = void 0;
var isContractLog = function (log, webhookData) {
    if (!webhookData.abis || !webhookData.abis[log.streamId]) {
        return false;
    }
    return true;
};
exports.isContractLog = isContractLog;
var hasAbis = function (webhookData) {
    if (!webhookData.abis) {
        return false;
    }
    return true;
};
exports.hasAbis = hasAbis;
var getTagStream = function (webhookData, tag) { var _a; return (_a = webhookData.logs.find(function (log) { return log.tag === tag; })) === null || _a === void 0 ? void 0 : _a.streamId; };
exports.getTagStream = getTagStream;
var getTagLogs = function (webhookData, tag) {
    return webhookData.logs.filter(function (log) { return log.tag === tag; });
};
exports.getTagLogs = getTagLogs;
var isWebhook = function (webhookData) {
    if (typeof webhookData !== 'object' || webhookData === null || !('logs' in webhookData)) {
        return false;
    }
    return true;
};
exports.isWebhook = isWebhook;
var isNotEmpty = function (value) { return value !== null && value !== undefined; };
exports.isNotEmpty = isNotEmpty;
